import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useCategoryApi } from '../../hooks/useCategoryApi';

type InitialDataType = { storeType?: string };

export const useAllCategory = (
  { initialData }: { initialData?: InitialDataType },
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey' | 'queryFn'>
) => {
  const { getAllCategory } = useCategoryApi();

  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getCategory', initialData?.storeType],
    queryFn: () => getAllCategory(initialData),
    retry: false,
    ...options, // now this won't cause a TS error
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};
